import React from 'react';
import { faTruckRampBox } from '@fortawesome/free-solid-svg-icons';
import AgvPageHeader, { PageHeaderButton } from '../../components/page-header';
import { TABS } from './truck-assignments.utils';

/**
 * En-tête de la page Affectations Camion : chiffres clés, actions et onglets
 * (« Envoyer en exploitation » quand le mode envoi est actif)
 */
export default function PageHeader({
  totalCount,
  summary,
  activeTab,
  onTabChange,
  alertsCount,
  onExport,
  canExport,
  onOpenVehiclesOfTheDay,
  dispatchAction,
}) {
  return (
    <AgvPageHeader
      icon={faTruckRampBox}
      breadcrumb={['Pilotage', 'Affectations Camion']}
      title="Affectations Camion"
      count={totalCount}
      summary={summary}
      activeTab={activeTab}
      onTabChange={onTabChange}
      tabs={[
        { key: TABS.ALL, icon: '☰', label: 'Toutes' },
        { key: TABS.UNASSIGNED, icon: '○', label: 'Non affectées' },
        { key: TABS.ASSIGNED, icon: '●', label: 'Affectées' },
        { key: TABS.ALERTS, icon: '⚠', label: 'Alertes', count: alertsCount },
      ]}
      actions={
        <>
          {/* Véhicules du jour : seulement quand la feature est activée */}
          {onOpenVehiclesOfTheDay && (
            <PageHeaderButton onClick={onOpenVehiclesOfTheDay}>
              Véhicules du jour
            </PageHeaderButton>
          )}
          <PageHeaderButton glyph="↓" onClick={onExport} disabled={!canExport}>
            Exporter en CSV
          </PageHeaderButton>
          {dispatchAction && (
            <PageHeaderButton
              primary
              glyph="➤"
              onClick={dispatchAction.onClick}
              disabled={dispatchAction.disabled}
              title={dispatchAction.title}
            >
              Envoyer en exploitation
            </PageHeaderButton>
          )}
        </>
      }
    />
  );
}
